import "../../App.css";
import { useState, useEffect } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../components/AuthContext";
import Appconfig from "../../config/config";
import axios from "axios";
import "react-notifications/lib/notifications.css";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import SkyLoader from "../../components/sky-loader";

// Custom hook to detect screen width
const useIsMobile = (breakpoint = 640) => {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false
  );

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);
    setIsMobile(mq.matches);
    const handler = (e) => setIsMobile(e.matches);
    if (mq.addEventListener) mq.addEventListener("change", handler);
    else mq.addListener(handler);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", handler);
      else mq.removeListener(handler);
    };
  }, [breakpoint]);

  return isMobile;
};

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const isMobile = useIsMobile(640);

  // ADD THIS USEEFFECT BLOCK
  useEffect(() => {
    // 1. Find the existing meta tag
    const meta = document.querySelector('meta[name="viewport"]');
    
    // 2. Store the original content to restore it later
    const previousContent = meta ? meta.getAttribute('content') : "width=1200, initial-scale=0.1";

    // 3. Set the Login-specific viewport
    if (meta) {
      meta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
    }

    // 4. Cleanup function: Revert back to 1200px when leaving the Login page
    return () => {
      if (meta) {
        meta.setAttribute('content', previousContent);
      }
    };
  }, []);

  const [user_nameValidationError, setUser_NameValidationError] = useState(
    "Please enter username"
  );
  const [passwordValidationError, setPasswordValidationError] = useState(
    "Please enter password"
  );
  const [validationError, setValidationError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setformData] = useState({
    user_name: "",
    password: "",
    site_code: Appconfig.sitecodes,
    user_type: "Super",
  });

  const togglePasswordVisibility = () => setShowPassword((s) => !s);

  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaError, setCaptchaError] = useState("");

  const generateCaptchaCode = () => {
    const code = Math.floor(1000 + Math.random() * 9000).toString();
    setCaptcha(code);
  };

  useEffect(() => {
    generateCaptchaCode();
  }, []);

  // Removed the Viewport Meta Tag logic as it causes re-renders and is better handled in index.html

  function checkValidation() {
    let isValid = true;
    if (formData.user_name.trim() === "") {
      setUser_NameValidationError("Please enter username");
      document.querySelector(".username-error")?.classList.remove("hidden");
      isValid = false;
    }

    if (formData.password === "") {
      setPasswordValidationError("Please enter password");
      document.querySelector(".password-error")?.classList.remove("hidden");
      isValid = false;
    }

    const regex = /^[a-zA-Z0-9]*$/;
    if (!regex.test(formData.user_name)) {
      setUser_NameValidationError("Username is only allow a-z and 0-9.");
      document.querySelector(".username-error")?.classList.remove("hidden");
      isValid = false;
    }

    if (isValid) return true;
    return false;
  }

  const handleInputChange = (event) => {
    setformData((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));

    // Hide errors on input
    if (event.target.name === "user_name") {
      document.querySelector(".username-error")?.classList.add("hidden");
    }
    if (event.target.name === "password") {
      document.querySelector(".password-error")?.classList.add("hidden");
    }
    if (event.target.name === "captchaInput") {
      // Assuming you might name your captcha input
      setCaptchaError("");
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setValidationError("");
    if (checkValidation()) {
      if (captchaInput !== captcha) {
        setCaptchaError("Incorrect captcha");
        generateCaptchaCode();
        return;
      }
      setIsLoading(true);

      var config = {
        method: "post",
        url: `${Appconfig.apiUrl}users/userAuthenticate`,
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(formData),
      };
      axios(config)
        .then(function (response) {
          // Reset fields safely
          setformData((prev) => ({ ...prev, user_name: "", password: "" }));
          setCaptchaInput("");

          if (response.data.result) {
            storeUserinfo(response.data.resultData);
          } else {
            setValidationError(response.data.resultMessage);
            errorNotification();
            generateCaptchaCode();
          }
          setIsLoading(false);
        })
        .catch(function (error) {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  function storeUserinfo(userdata) {
    login(userdata);
    setTimeout(() => {
      setIsLoading(false);
      navigate("/list/user");
    }, 1000);
  }

  const errorNotification = () => {
    NotificationManager.error("Invalid Login Credential!", "", 3000);
  };

  return (
    <>
      <NotificationContainer />
      {isLoading && <SkyLoader />}

      <div className="absolute w-full left-0 top-0">
        {/* =================================================================
            MOBILE LAYOUT
           ================================================================= */}
        {isMobile ? (
          <div className="w-full left-0 top-0 flex justify-center">
            <div className="relative w-full flex flex-col items-center h-screen overflow-auto z-[999] bg-[#ffb600]">
              {/* Top Header/Logo Section */}
              <div
                className="relative w-full h-[280px] flex flex-col items-center justify-center pt-10"
                style={{
                  background: "url(/images/KV-pic.png) no-repeat center bottom",
                  backgroundSize: "cover",
                }}
              >
                <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
                  <img
                    src="/logos/logo.png"
                    alt="Skyexch Logo"
                    className="w-24 h-24"
                  />
                </div>
              </div>

              {/* Form Container Section */}
              <div className="w-full relative -mt-[50px] px-2 flex items-center justify-center">
                <div className="max-w-[80%] absolute top-[100px]">
                  <form
                    method="post"
                    onSubmit={handleSubmit}
                    autoComplete="off"
                    noValidate
                    className="w-full"
                  >
                    {validationError && (
                      <div className="mb-3 text-sm text-red-700">
                        {validationError}
                      </div>
                    )}

                    {/* Username */}
                    <div className="mb-3">
                      <input
                        value={formData.user_name}
                        onChange={handleInputChange}
                        type="text"
                        name="user_name"
                        placeholder="Username"
                        className="w-full p-1 h-[37px] rounded-md border-2 border-transparent focus:border-black focus:outline-none placeholder-gray-400 text-sx"
                      />
                    </div>

                    {/* Password */}
                    <div className="mb-3">
                      <div className="relative">
                        <input
                          value={formData.password}
                          onChange={handleInputChange}
                          type={showPassword ? "text" : "password"}
                          name="password"
                          placeholder="Password"
                          className="w-full p-1 rounded-md border-2 border-transparent focus:border-black focus:outline-none placeholder-gray-400 text-sx"
                        />
                        <button
                          type="button"
                          aria-label={
                            showPassword ? "Hide password" : "Show password"
                          }
                          onClick={togglePasswordVisibility}
                          className="absolute right-2 top-1/2 -translate-y-1/2 text-black text-[18px]"
                        >
                          {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                      </div>
                    </div>

                    {/* Captcha */}
                    <div className="relative w-full mb-3">
                      <input
                        value={captchaInput}
                        onChange={(e) => {
                          setCaptchaInput(e.target.value);
                          setCaptchaError("");
                        }}
                        type="text"
                        maxLength={4}
                        placeholder="Validation Code"
                        className="w-full p-1 pr-28 rounded-md border-2 border-transparent focus:border-black focus:outline-none placeholder-gray-400 text-sx"
                      />
                      <span
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-black font-bold text-xl tracking-widest select-none bg-none p-1 rounded-md px-3 cursor-pointer"
                        onClick={generateCaptchaCode}
                      >
                        {captcha}
                      </span>
                      {captchaError && (
                        <span className="text-red-700 text-sm mt-1 block">
                          {captchaError}
                        </span>
                      )}
                    </div>

                    {/* Submit */}
                    <div className="mb-3">
                      <button
                        type="submit"
                        className="w-full h-[40px] rounded-md text-sm font-bold text-[#ffb600] bg-gradient-to-t from-[#070707] to-[#474747] shadow-lg"
                      >
                        Login
                      </button>
                    </div>
                  </form>

                  {/* Mobile Footer Links */}
                  <div className="flex flex-col gap-3">
                    {/* Contact Links */}
                    <div className="flex flex-col gap-3">
                      {/* Customer Support */}
                      <div className="w-full h-11 bg-[rgba(255,255,255,.6)] rounded-md  flex items-center justify-center">
                        <svg
                          width="26"
                          height="26"
                          viewBox="0 0 160 160"
                          xmlns="http://www.w3.org/2000/svg"
                          className="text-black fill-current mr-2"
                        >
                          <path
                            d="M125.436 95.33c-.453 4.682-2.987 7.98-7.26 9.898-.83.372-1.207.754-1.295 1.729-.542 5.899-4.402 10.21-9.985 11.099-2.427.386-4.905.057-6.92.131-2.593 0-4.746.017-6.9-.01-.675-.008-1.012.24-1.248.888-1.268 3.486-3.987 5.356-7.713 5.361-2.928.006-5.855.011-8.782-.003-3.507-.017-6.301-1.867-7.428-4.89-1.2-3.216-.33-6.768 2.216-9.03 1.487-1.322 3.295-1.814 5.217-1.848a287 287 0 0 1 9.085-.007c3.334.044 6.2 2.077 7.333 5.224.277.77.65 1.032 1.45 1.024 3.904-.035 7.807.005 11.71-.023 4.399-.031 7.776-2.947 8.492-7.278.194-1.175.053-1.34-1.162-1.35-.673-.004-1.347 0-2.02 0-3.092-.006-4.605-1.5-4.606-4.566-.003-7.167-.001-14.334-.001-21.501 0-2.12-.013-4.24.004-6.36.02-2.525 1.276-4.055 3.782-4.244 3.402-.256 6.834-.295 9.92 1.514 4.001 2.346 6.15 5.912 6.243 10.526.093 4.57.31 9.157-.132 13.717M50.55 63.55c-.13.63-.317 1.05-1.07 1.061-2.795.044-5.566.365-8.318.833-.733.124-.94-.057-.873-.83.622-7.134 3.087-13.56 7.561-19.14 3.844-4.796 8.788-8.626 14.517-10.895 5.509-2.18 11.492-2.866 17.418-2.83 1.734.011 3.464.084 5.174.199 2.638.177 5.28.404 7.882.89 2.809.517 5.68 1.71 8.227 2.993a35.227 35.227 0 0 1 12.46 10.468c3.323 4.49 5.52 9.757 6.478 15.256.09.515.169 1.032.237 1.55.11.838.145 1.673.18 2.513.019.432-.152.558-.543.375-2.894-1.351-5.982-1.453-9.09-1.384-.745.016-1.047-.272-1.206-1.008-1.717-7.993-6.139-14.007-13.31-17.955a24.249 24.249 0 0 0-11.19-3.032 173.892 173.892 0 0 0-9.89-.002c-6.253.192-11.744 2.422-16.417 6.572-4.342 3.856-7.055 8.682-8.227 14.367m4.202 38.236c-.004 2.884-1.553 4.472-4.417 4.436-2.25-.029-4.51.22-6.747-.185-4.812-.87-8.388-4.805-8.648-9.688-.308-5.777-.321-11.563.016-17.34.273-4.676 4.606-8.957 9.263-9.363 1.983-.172 3.963-.172 5.946-.147 3.076.04 4.585 1.582 4.588 4.636.004 4.575.001 9.149 0 13.724 0 4.643.005 9.285-.001 13.927M79.52 0h-.04C35.646 0 0 35.656 0 79.5c0 17.39 5.605 33.509 15.135 46.597L5.227 155.63l30.558-9.769C48.355 154.19 63.351 159 79.52 159c43.834 0 79.48-35.666 79.48-79.5S123.354 0 79.52 0"
                            fill="rgba(0,0,0,.7)"
                            fillRule="nonzero"
                          />
                        </svg>
                        <span className="text-[rgba(0,0,0,.7)] text-base font-medium">
                          Customer support1
                        </span>
                        <span className="text-gray-600 px-1">|</span>
                        <span className="text-[rgba(0,0,0,.7)] text-base font-medium">
                          support2
                        </span>
                      </div>

                      {/* WhatsApp Links */}
                      <div className="w-full h-11 bg-[rgba(255,255,255,.6)] rounded-md  flex items-center justify-center">
                        <svg
                          width="22"
                          height="22"
                          xmlns="http://www.w3.org/2000/svg"
                          className="text-black fill-current mr-2"
                        >
                          <path
                            d="M11.002 1h-.005C5.485 1 1 5.485 1 11c0 2.188.705 4.215 1.904 5.861l-1.246 3.715L5.5 19.347A9.913 9.913 0 0011.002 21C16.517 21 21 16.514 21 11S16.516 1 11.002 1zm5.82 14.121c-.242.681-1.2 1.246-1.963 1.412-.523.11-1.205.2-3.503-.753-2.938-1.218-4.831-4.204-4.978-4.398-.142-.193-1.188-1.58-1.188-3.016 0-1.435.729-2.134 1.022-2.434.242-.246.64-.358 1.023-.358.124 0 .235.006.335.011.294.012.441.03.635.494.241.581.829 2.016.899 2.163.071.148.142.348.042.542-.094.2-.176.288-.324.458-.147.17-.287.3-.434.483-.136.159-.288.329-.118.622.17.288.758 1.247 1.623 2.017 1.116.993 2.02 1.311 2.345 1.446.24.1.528.076.705-.111.223-.242.5-.642.78-1.035.2-.283.453-.318.718-.218.27.094 1.699.8 1.993.946.293.148.487.218.558.342.07.123.07.705-.17 1.387z"
                            fill="rgba(0,0,0,.7)"
                            fillRule="nonzero"
                          />
                        </svg>
                        <span className="text-[rgba(0,0,0,.7)] text-base font-medium">
                          WhatsApp 3
                        </span>
                        <span className="text-gray-600 px-1">|</span>
                        <span className="text-[rgba(0,0,0,.7)] text-base font-medium">
                          WhatsApp 4
                        </span>
                      </div>
                    </div>

                    {/* Placeholder for the other links/footer section shown in the previous layout */}
                    <div className="w-full bg-[rgba(255,255,255,.6)] rounded-xl shadow-sm border flex items-center justify-center gap-3 h-[20px] rounded-lg border border-[rgba(151,151,151,0.5)] text-[13px] justify-center"></div>

                    <div className="w-full flex items-center justify-between gap-1 flex-nowrap mt-3">
                      {/* Item 1: Skype */}
                      <div className="w-[32%] bg-[rgba(255,255,255,.6)] rounded-md shadow-sm border p-2 flex items-center gap-2 justify-center text-[rgba(255,255,255,.8)] flex-shrink-0">
                        <svg
                          width="22"
                          height="22"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20.425 13.123c.145-.652.22-1.327.22-2.02 0-5.193-4.27-9.404-9.539-9.404-.555 0-1.1.047-1.631.137A5.567 5.567 0 006.533 1C3.475 1 1 3.441 1 6.455c0 1.006.278 1.947.76 2.759a9.32 9.32 0 00-.194 1.89c0 5.195 4.272 9.406 9.539 9.406.598 0 1.181-.055 1.747-.158A5.58 5.58 0 0015.47 21C18.524 21 21 18.558 21 15.546c0-.871-.207-1.692-.575-2.423zm-4.426 2.476c-.442.616-1.093 1.104-1.939 1.448-.836.344-1.838.52-2.98.52-1.37 0-2.519-.238-3.416-.708a4.434 4.434 0 01-1.57-1.375c-.407-.575-.61-1.146-.61-1.699 0-.344.133-.643.397-.886.261-.244.596-.365.997-.365.327 0 .61.096.84.287.218.184.407.457.558.805.169.383.353.705.547.957.188.246.457.45.8.612.347.16.813.244 1.386.244.789 0 1.436-.166 1.921-.494.476-.319.706-.704.706-1.174 0-.37-.121-.662-.367-.891-.26-.24-.603-.426-1.018-.555a20.235 20.235 0 00-1.75-.427c-.991-.21-1.832-.457-2.5-.738-.683-.287-1.236-.685-1.638-1.183-.41-.506-.618-1.14-.618-1.885 0-.71.218-1.35.648-1.902.426-.549 1.048-.977 1.852-1.269.791-.288 1.733-.435 2.799-.435.851 0 1.6.098 2.226.29.629.193 1.159.453 1.575.774.42.325.733.669.928 1.029.197.362.298.724.298 1.072 0 .337-.131.643-.391.908a1.32 1.32 0 01-.98.404c-.352 0-.63-.087-.821-.253-.179-.156-.365-.4-.57-.747-.238-.445-.526-.797-.856-1.045-.322-.242-.857-.362-1.594-.362-.683 0-1.24.135-1.653.403-.397.256-.591.551-.591.901 0 .214.063.393.191.546.135.165.327.306.569.426.25.124.509.224.768.294.265.073.708.181 1.32.32.772.163 1.48.347 2.108.545a6.759 6.759 0 011.634.734c.456.294.818.g.g.c.g.c.a3.54 3.54 0 01-.67 2.098z"
                            fill="rgba(0,0,0,.7)"
                            fillRule="nonzero"
                          />
                        </svg>
                        <span className="text-[13px] text-[rgba(0,0,0,.7)] whitespace-nowrap">
                          Skype
                        </span>
                      </div>

                      {/* Item 2: Email */}
                      <div className="w-[32%] bg-[rgba(255,255,255,.6)] rounded-md shadow-sm p-2 flex items-center gap-2 justify-center text-[rgba(255,255,255,.8)] flex-shrink-0">
                        <svg
                          width="22"
                          height="22"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g fill="rgba(0,0,0,.7)" fillRule="nonzero">
                            <path d="M8.292 15.677v3.865a.626.626 0 001.128.37l2.26-3.077-3.388-1.158zM20.738 1.116a.625.625 0 00-.652-.045l-18.75 9.792a.627.627 0 00.087 1.145l5.212 1.782 11.1-9.492-8.59 10.35 8.737 2.985a.628.628 0 00.82-.5l2.291-15.416a.626.626 0 00-.255-.601z" />
                          </g>
                        </svg>
                        <span className="text-[13px] text-[rgba(0,0,0,.7)] whitespace-nowrap">
                          Email
                        </span>
                      </div>

                      {/* Item 3: skyexchindia */}
                      <div className="w-[32%] bg-[rgba(255,255,255,.6)] rounded-md shadow-sm p-2 flex items-center gap-1 justify-center text-[rgba(255,255,255,.8)] flex-shrink-0">
                        <svg
                          /* REMOVED: width="100" */
                          /* REMOVED: height="20" */
                          viewBox="0 0 40 40"
                          xmlns="http://www.w3.org/2000/svg"
                          /* ADDED: Tailwind classes to set a consistent, square size (e.g., 22px by 22px) */
                          className="w-[100px] h-[22px]"
                        >
                          <path
                            d="M29.172 0C35.142 0 40 4.857 40 10.828v18.345C40 35.143 35.143 40 29.173 40H10.828C4.858 40 0 35.143 0 29.173V10.828C0 4.858 4.857 0 10.828 0zM20 9.063C13.97 9.063 9.063 13.969 9.063 20c0 6.03 4.906 10.937 10.937 10.937 6.03 0 10.937-4.906 10.937-10.937 0-6.03-4.906-10.937-10.937-10.937zm0 2.345c4.738 0 8.592 3.854 8.592 8.592S24.738 28.592 20 28.592 11.408 24.738 11.408 20s3.854-8.592 8.592-8.592zm11.199-6.23a3.235 3.235 0 00-3.232 3.232 3.235 3.235 0 003.232 3.232A3.235 3.235 0 0034.43 8.41a3.236 3.236 0 00-3.232-3.232zm0 2.345a.888.888 0 010 1.774.888.888 0 010-1.774z"
                            fill="rgba(0,0,0,0.7)"
                            fillRule="nonzero"
                          />
                        </svg>
                        <span className="text-[11px] text-[rgba(0,0,0,.7)] whitespace-nowrap">
                          skyexchindia
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="h-20"></div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          /* =================================================================
            DESKTOP LAYOUT
           ================================================================= */
          <div className="w-full left-0 top-0 flex justify-center min-w-[980px]">
            <div className="login-bg relative w-full flex flex-col items-center h-screen overflow-auto z-[999] min-w-[980px]">
              <div className="w-full relative px-[10px] pt-[5%] flex justify-center">
                <div className="w-[540px] h-[400px] rounded-[8px] [box-shadow:0_5px_20px_#00000080] flex bg-[linear-gradient(180deg,_#ffb600_1%,_#ffb600_100%)]">
                  {/* Left Image Section */}
                  <div className="login-form-left relative w-[270px] rounded-tl-[8px] rounded-bl-[8px]"></div>

                  {/* Right Form Section */}
                  <div className="flex flex-col items-start justify-center w-full max-w-[270px] ml-5 p-4">
                    <span className="ml-5 mb-3 text-[20px] font-medium whitespace-nowrap">
                      Agent Login
                    </span>
                    <form
                      method="post"
                      onSubmit={handleSubmit}
                      autoComplete="off"
                      noValidate
                      className="w-full max-w-[250px] px-[18px]"
                    >
                      {validationError && (
                        <div className="mb-3 text-sm text-red-500">
                          {validationError}
                        </div>
                      )}

                      {/* Desktop Username */}
                      <div className="mb-[.7rem]">
                        <div className="relative bg-[white] h-[33px] rounded-[5px] flex items-center">
                          <input
                            id="desktop-user"
                            value={formData.user_name}
                            onChange={handleInputChange}
                            className="bg-white outline-none h-[33px] text-[14px] border border-[#aaa] shadow-[inset_0px_2px_0px_0px_rgba(0,0,0,0.1)] text-black border-transparent block w-full px-3 py-2 text-base font-normal leading-normal appearance-none rounded-md"
                            type="text"
                            tabIndex="1"
                            name="user_name"
                            placeholder="Username"
                            maxLength={30}
                          />
                        </div>
                        <span className="username-error hidden text-[0.813rem] text-white leading-[14px]">
                          <div className="leading-[14px] pt-[5px]">
                            {user_nameValidationError}
                          </div>
                        </span>
                      </div>

                      {/* Desktop Password */}
                      <div className="mb-[.7rem]">
                        <div className="relative bg-[white] h-[33px] rounded-[5px] flex items-center">
                          <input
                            id="desktop-pass"
                            value={formData.password}
                            onChange={handleInputChange}
                            className="bg-white outline-none h-[33px] text-[14px] border border-[#aaa] shadow-[inset_0px_2px_0px_0px_rgba(0,0,0,0.1)] text-black border-transparent block w-full px-3 py-2 text-base font-normal leading-normal appearance-none rounded-md"
                            type={showPassword ? "text" : "password"}
                            tabIndex="1"
                            minLength={6}
                            name="password"
                            placeholder="Password"
                          />
                          <button
                            type="button"
                            onClick={togglePasswordVisibility}
                            className="absolute right-2 top-1/2 -translate-y-1/2 text-black text-[14px]"
                          >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </button>
                        </div>
                        <span className="password-error hidden text-[0.813rem] text-white leading-[14px]">
                          <div className="leading-[14px] pt-[5px]">
                            {passwordValidationError}
                          </div>
                        </span>
                      </div>

                      {/* Desktop Captcha */}
                      <div className="relative w-full mb-4">
                        <input
                          value={captchaInput}
                          onChange={(e) => {
                            setCaptchaInput(e.target.value);
                            setCaptchaError("");
                          }}
                          type="text"
                          maxLength={4}
                          placeholder="Validation Code"
                          className="w-full bg-white outline-none h-[33px] text-[14px] border border-[#aaa] shadow-[inset_0px_2px_0px_0px_rgba(0,0,0,0.1)] text-black px-3 pr-20 rounded-md placeholder-gray-500"
                        />
                        <span
                          className="absolute right-3 top-[50%] -translate-y-1/2 text-black font-bold text-[20px] tracking-[-2px] select-none cursor-pointer"
                          onClick={generateCaptchaCode}
                        >
                          {captcha}
                        </span>
                        {captchaError && (
                          <span className="text-red-400 text-sm">
                            {captchaError}
                          </span>
                        )}
                      </div>

                      {/* Desktop Submit */}
                      <div>
                        <button
                          type="submit"
                          className="flex items-center h-[36px] justify-center bg-[linear-gradient(180deg,#474747_0%,#070707_100%)] text-[#ffb600] [box-shadow:none] rounded-[5px] text-[16px] font-bold leading-[2.6] text-center block w-full border-[unset]"
                        >
                          Login
                          <svg
                            className="ml-[5px]"
                            width="10"
                            height="11"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.71 7.706l1.432-1.604H1.778V4.898h5.39L5.71 3.294l.781-.86L9.278 5.5 6.49 8.565l-.78-.86zM1.12 0C.825 0 .564.124.339.372a1.24 1.24 0 0 0-.339.86v8.536c0 .325.113.611.339.86.225.248.486.372.78.372H8.88c.295 0 .556-.124.781-.372a1.24 1.24 0 0 0 .339-.86V7.333H8.88v2.435H1.12V1.232h7.76v2.435H10V1.232a1.24 1.24 0 0 0-.339-.86C9.436.124 9.175 0 8.881 0H1.12z"
                              fill="currentColor"
                              fillRule="evenodd"
                            ></path>
                          </svg>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* Desktop Footer Content (Preserved) */}
              <div className="w-full flex flex-col items-center py-10">
                <div className="w-[550px] flex flex-col items-center">
                  <div className="w-full flex flex-row justify-center gap-2">
                    <div className="w-[270px] bg-[rgba(0,0,0,0.5)] rounded-xl shadow-sm border p-2 flex items-center justify-center gap-3 h-[60px] py-2 rounded-lg border border-[rgba(151,151,151,0.5)] text-[13px] text-[rgba(255,255,255,.8)] flex-shrink-0">
                      <svg
                        width="26"
                        height="26"
                        viewBox="0 0 160 160"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M125.436 95.33c-.453 4.682-2.987 7.98-7.26 9.898-.83.372-1.207.754-1.295 1.729-.542 5.899-4.402 10.21-9.985 11.099-2.427.386-4.905.057-6.92.131-2.593 0-4.746.017-6.9-.01-.675-.008-1.012.24-1.248.888-1.268 3.486-3.987 5.356-7.713 5.361-2.928.006-5.855.011-8.782-.003-3.507-.017-6.301-1.867-7.428-4.89-1.2-3.216-.33-6.768 2.216-9.03 1.487-1.322 3.295-1.814 5.217-1.848a287 287 0 0 1 9.085-.007c3.334.044 6.2 2.077 7.333 5.224.277.77.65 1.032 1.45 1.024 3.904-.035 7.807.005 11.71-.023 4.399-.031 7.776-2.947 8.492-7.278.194-1.175.053-1.34-1.162-1.35-.673-.004-1.347 0-2.02 0-3.092-.006-4.605-1.5-4.606-4.566-.003-7.167-.001-14.334-.001-21.501 0-2.12-.013-4.24.004-6.36.02-2.525 1.276-4.055 3.782-4.244 3.402-.256 6.834-.295 9.92 1.514 4.001 2.346 6.15 5.912 6.243 10.526.093 4.57.31 9.157-.132 13.717M50.55 63.55c-.13.63-.317 1.05-1.07 1.061-2.795.044-5.566.365-8.318.833-.733.124-.94-.057-.873-.83.622-7.134 3.087-13.56 7.561-19.14 3.844-4.796 8.788-8.626 14.517-10.895 5.509-2.18 11.492-2.866 17.418-2.83 1.734.011 3.464.084 5.174.199 2.638.177 5.28.404 7.882.89 2.809.517 5.68 1.71 8.227 2.993a35.227 35.227 0 0 1 12.46 10.468c3.323 4.49 5.52 9.757 6.478 15.256.09.515.169 1.032.237 1.55.11.838.145 1.673.18 2.513.019.432-.152.558-.543.375-2.894-1.351-5.982-1.453-9.09-1.384-.745.016-1.047-.272-1.206-1.008-1.717-7.993-6.139-14.007-13.31-17.955a24.249 24.249 0 0 0-11.19-3.032 173.892 173.892 0 0 0-9.89-.002c-6.253.192-11.744 2.422-16.417 6.572-4.342 3.856-7.055 8.682-8.227 14.367m4.202 38.236c-.004 2.884-1.553 4.472-4.417 4.436-2.25-.029-4.51.22-6.747-.185-4.812-.87-8.388-4.805-8.648-9.688-.308-5.777-.321-11.563.016-17.34.273-4.676 4.606-8.957 9.263-9.363 1.983-.172 3.963-.172 5.946-.147 3.076.04 4.585 1.582 4.588 4.636.004 4.575.001 9.149 0 13.724 0 4.643.005 9.285-.001 13.927M79.52 0h-.04C35.646 0 0 35.656 0 79.5c0 17.39 5.605 33.509 15.135 46.597L5.227 155.63l30.558-9.769C48.355 154.19 63.351 159 79.52 159c43.834 0 79.48-35.666 79.48-79.5S123.354 0 79.52 0"
                          fill="rgb(166,166,166)"
                          fillRule="nonzero"
                        />
                      </svg>
                      <span className="text-[13px] whitespace-nowrap">
                        Customer support1
                      </span>
                      <span className="text-gray-400">|</span>
                      <span className="text-[13px] whitespace-nowrap">
                        support2
                      </span>
                    </div>

                    <div className="w-[270px] bg-[rgba(0,0,0,0.5)] rounded-xl shadow-sm border p-2 flex items-center justify-center gap-3 h-[60px] py-2 rounded-lg border border-[rgba(151,151,151,0.5)] text-[13px] text-[rgba(255,255,255,.8)] flex-shrink-0">
                      <svg
                        width="22"
                        height="22"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.002 1h-.005C5.485 1 1 5.485 1 11c0 2.188.705 4.215 1.904 5.861l-1.246 3.715L5.5 19.347A9.913 9.913 0 0011.002 21C16.517 21 21 16.514 21 11S16.516 1 11.002 1zm5.82 14.121c-.242.681-1.2 1.246-1.963 1.412-.523.11-1.205.2-3.503-.753-2.938-1.218-4.831-4.204-4.978-4.398-.142-.193-1.188-1.58-1.188-3.016 0-1.435.729-2.134 1.022-2.434.242-.246.64-.358 1.023-.358.124 0 .235.006.335.011.294.012.441.03.635.494.241.581.829 2.016.899 2.163.071.148.142.348.042.542-.094.2-.176.288-.324.458-.147.17-.287.3-.434.483-.136.159-.288.329-.118.622.17.288.758 1.247 1.623 2.017 1.116.993 2.02 1.311 2.345 1.446.24.1.528.076.705-.111.223-.242.5-.642.78-1.035.2-.283.453-.318.718-.218.27.094 1.699.8 1.993.946.293.148.487.218.558.342.07.123.07.705-.17 1.387z"
                          fill="rgb(166,166,166)"
                          fillRule="nonzero"
                        />
                      </svg>
                      <span className="text-[13px] whitespace-nowrap">
                        WhatsApp 3
                      </span>
                      <span className="text-gray-400">|</span>
                      <span className="text-[13px] whitespace-nowrap">
                        WhatsApp 4
                      </span>
                    </div>
                  </div>

                  <div className="w-[550px] bg-[rgba(0,0,0,0.5)] rounded-xl shadow-sm border flex items-center justify-center gap-3 h-[20px] rounded-lg border border-[rgba(151,151,151,0.5)] text-[13px] justify-center mt-3"></div>

                  <div className="w-[550px] flex items-center justify-between gap-2 flex-nowrap mt-3">
                    <div className=" bg-[rgba(0,0,0,0.5)] rounded-xl shadow-sm border p-4 flex items-center justify-center gap-3 border border-[rgba(151,151,151,0.5)] text-[rgba(255,255,255,.8)] flex-shrink-0">
                      <svg
                        width="22"
                        height="22"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20.425 13.123c.145-.652.22-1.327.22-2.02 0-5.193-4.27-9.404-9.539-9.404-.555 0-1.1.047-1.631.137A5.567 5.567 0 006.533 1C3.475 1 1 3.441 1 6.455c0 1.006.278 1.947.76 2.759a9.32 9.32 0 00-.194 1.89c0 5.195 4.272 9.406 9.539 9.406.598 0 1.181-.055 1.747-.158A5.58 5.58 0 0015.47 21C18.524 21 21 18.558 21 15.546c0-.871-.207-1.692-.575-2.423zm-4.426 2.476c-.442.616-1.093 1.104-1.939 1.448-.836.344-1.838.52-2.98.52-1.37 0-2.519-.238-3.416-.708a4.434 4.434 0 01-1.57-1.375c-.407-.575-.61-1.146-.61-1.699 0-.344.133-.643.397-.886.261-.244.596-.365.997-.365.327 0 .61.096.84.287.218.184.407.457.558.805.169.383.353.705.547.957.188.246.457.45.8.612.347.16.813.244 1.386.244.789 0 1.436-.166 1.921-.494.476-.319.706-.704.706-1.174 0-.37-.121-.662-.367-.891-.26-.24-.603-.426-1.018-.555a20.235 20.235 0 00-1.75-.427c-.991-.21-1.832-.457-2.5-.738-.683-.287-1.236-.685-1.638-1.183-.41-.506-.618-1.14-.618-1.885 0-.71.218-1.35.648-1.902.426-.549 1.048-.977 1.852-1.269.791-.288 1.733-.435 2.799-.435.851 0 1.6.098 2.226.29.629.193 1.159.453 1.575.774.42.325.733.669.928 1.029.197.362.298.724.298 1.072 0 .337-.131.643-.391.908a1.32 1.32 0 01-.98.404c-.352 0-.63-.087-.821-.253-.179-.156-.365-.4-.57-.747-.238-.445-.526-.797-.856-1.045-.322-.242-.857-.362-1.594-.362-.683 0-1.24.135-1.653.403-.397.256-.591.551-.591.901 0 .214.063.393.191.546.135.165.327.306.569.426.25.124.509.224.768.294.265.073.708.181 1.32.32.772.163 1.48.347 2.108.545a6.759 6.759 0 011.634.734c.456.294.818.669 1.075 1.119.258.454.388 1.01.388 1.657a3.54 3.54 0 01-.67 2.098z"
                          fill="rgb(166,166,166)"
                          fillRule="nonzero"
                        />
                      </svg>
                      <span className="text-[13px] whitespace-nowrap">
                        skyexchangeofficial
                      </span>
                    </div>

                    <div className=" bg-[rgba(0,0,0,0.5)] rounded-xl shadow-sm border p-4 flex items-center justify-center gap-3 border border-[rgba(151,151,151,0.5)] text-[rgba(255,255,255,.8)] flex-shrink-0">
                      <svg
                        width="22"
                        height="22"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g fill="rgb(166,166,166)" fillRule="nonzero">
                          <path d="M8.292 15.677v3.865a.626.626 0 001.128.37l2.26-3.077-3.388-1.158zM20.738 1.116a.625.625 0 00-.652-.045l-18.75 9.792a.627.627 0 00.087 1.145l5.212 1.782 11.1-9.492-8.59 10.35 8.737 2.985a.628.628 0 00.82-.5l2.291-15.416a.626.626 0 00-.255-.601z" />
                        </g>
                      </svg>
                      <span className="text-[13px] whitespace-nowrap">
                        info@skyexchange.com
                      </span>
                    </div>

                    <div className=" bg-[rgba(0,0,0,0.5)] rounded-xl shadow-sm border p-4 flex items-center justify-center gap-3 border border-[rgba(151,151,151,0.5)] text-[rgba(255,255,255,.8)] flex-shrink-0">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 40 40"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M29.172 0C35.142 0 40 4.857 40 10.828v18.345C40 35.143 35.143 40 29.173 40H10.828C4.858 40 0 35.143 0 29.173V10.828C0 4.858 4.857 0 10.828 0zM20 9.063C13.97 9.063 9.063 13.969 9.063 20c0 6.03 4.906 10.937 10.937 10.937 6.03 0 10.937-4.906 10.937-10.937 0-6.03-4.906-10.937-10.937-10.937zm0 2.345c4.738 0 8.592 3.854 8.592 8.592S24.738 28.592 20 28.592 11.408 24.738 11.408 20s3.854-8.592 8.592-8.592zm11.199-6.23a3.235 3.235 0 00-3.232 3.232 3.235 3.235 0 003.232 3.232A3.235 3.235 0 0034.43 8.41a3.236 3.236 0 00-3.232-3.232zm0 2.345a.888.888 0 010 1.774.888.888 0 010-1.774z"
                          fill="rgb(166,166,166)"
                          fillRule="nonzero"
                        />
                      </svg>
                      <span className="text-[13px] whitespace-nowrap">
                        skyexchindia
                      </span>
                    </div>
                  </div>

                  <div className="relative w-full mt-3">
                    <div className="w-[550px] mx-auto mb-[30px] bg-[rgba(255,255,255,0.25)] rounded-[8px] px-[10px] py-[5px] text-[rgba(0,0,0,0.6)] border border-[rgba(0,0,0,0.3)] flex items-start">
                      <h3 id="powerWrapW" style={{ display: "none" }}>
                        <span>Powered by</span>
                        <img
                          src="/images/transparent.gif"
                          alt=""
                          className="inline-block ml-2"
                        />
                      </h3>
                      <div className="licence_embed my-2 rounded-md">
                        <iframe
                          title="Curacao licence"
                          src="https://licensing.gaming-curacao.com/validator/?lh=7a83475c9e54450a218a18bd28e33fad&template=seal"
                          width="150"
                          height="50"
                          style={{ border: "none", background: "white" }}
                          loading="lazy"
                          allowTransparency={true}
                        />
                      </div>
                      <div className="flex flex-col items-end">
                        <p className="text-[11px] leading-[14px] p-2 text-right">
                          Sky Infotech Limited is licensed and regulated by
                          Government of Curacao under license no 365/JAZ
                          Sub-License GLH-OCCHKTW0707072017.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col items-center">
                    <div className="browser-images">
                      <img
                        src="/images/icon-browser-W.png"
                        alt="supported browsers"
                      ></img>
                    </div>
                    <div className="flex flex-col items-center">
                      <p className="text-[rgba(255,255,255,.8)] text-[11px] text-center">
                        Our website works best in the newest and last prior
                        version of these browsers:
                      </p>
                      <p className="text-[rgba(255,255,255,.8)] text-[11px] text-center">
                        Google Chrome. Firefox
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default Login;
